var BundleBuilder = {
  component: function() {
    return RshopApp.$children.find(function(component) {
      return component.$vnode.componentOptions.tag == "bundle-builder";
    });
  }
};

function addProductToBundle(productId, productVariationId) {
  $(".js-bundle-builder-modal").modal("show");

  var variation_values = {};

  for (var i = 1; i < 5; i++) {
    var $checkedColors = $(
      '[data-element="filterItem"][data-type="variations"][data-variation="' +
        i +
        '"]:checked'
    );

    if ($checkedColors.size() == 1) {
      variation_values[i] = $checkedColors.data("raw-value");
    }
  }

  $.post(
    "/rshop-api/products/map",
    { product_id: productId, product_variation_id: productVariationId, variation_values: variation_values },
    function(response) {
      if (!response.status) {
        return;
      }

      BundleBuilder.component().product = response.result.map;
      BundleBuilder.component().afterFetch();
    },
    "json"
  );
}

rEvent.on("BundleBuilder.updated", function() {
  tippy(".js-tippy", {
    arrow: true
  });
});

$(document).on("hidden.bs.modal", ".js-bundle-builder-modal", function() {
  BundleBuilder.component().product = {};
  BundleBuilder.component().editingIndex = -1;
});

$(document).on('click', '.js-product-thumb.is-bundle-builder a', function(e) {
  var productId = $(this).closest('.js-product-thumb').data('id');

  if (new RegExp('-p' + productId + '$').exec($(this).attr('href')) !== null) {
    e.preventDefault();
    addProductToBundle(productId);
  }
});

Vue.component("bundle-builder", {
  props: {
    id: {
      required: false,
      default: null
    }
  },
  template: "#bundleBuilderTemplate",
  name: "bundle-builder",
  data: function() {
    return {
      bundle: [],
      cleared: false,
      product: {},
      total: 0,
      currencyValue: 1,
      discount: 0,
      editingIndex: -1,
      loadingVariation: false,
      addedToCart: false,
      productTypes: JSON.parse(
        document.querySelector("#productTypesJson").innerHTML
      )
    };
  },
  created: function() {
    var _self = this;

    if (typeof this.productTypes === 'object') {
      this.productTypes = Object.keys(this.productTypes).map(function(e) {
        return _self.productTypes[e];
      });
    }

    if (typeof bundleId != "undefined" && bundleId) {
      this.id = bundleId;
    }

    if (localStorage.getItem("currencyValue") == null) {
      this.fetch("get", "/fetch-currency", {}, function (response) {
        _self.currencyValue = response.currencyValue;
        localStorage.setItem("currencyValue", response.currencyValue);
      });
    } else {
      _self.currencyValue = localStorage.getItem("currencyValue");
    }

    if (this.id == null) {
      var storedData = localStorage.getItem("NewBundle");

      this.bundle =
        storedData != null ? JSON.parse(localStorage.getItem("NewBundle")) : [];
    } else {
      this.fetchBundleProducts();
    }

    if (this.bundle == null) {
      this.bundle = [];
    }
  },
  methods: {
    addProduct: function() {
      if (
        this.product.has_variations &&
        this.product.variations.length !=
          Object.keys(this.product.selected_variation_values).length
      ) {
        return false;
      }

      if (this.alreadyInBundle) {
        return false;
      }

      this.product.bundle_configurator_price = this.calculateNewProductPrice(
        this.product.price_vat,
        this.getDiscountRate(this.product)
      );

      if (this.editingIndex === -1) {
        this.bundle.push(this.product);
      } else {
        this.bundle.splice(this.editingIndex, 1, this.product);
      }

      this.product = {};

      Eshop.alert($('html').attr('lang') == 'sk' ? 'Produkt bol pridaný do setu.' : 'Produkt byl přidán do setu.');
      $(".js-bundle-builder-modal").modal("hide");
    },
    editProduct: function(product) {
      this.product = JSON.parse(JSON.stringify(product));

      this.editingIndex = this.bundle
        .map(function(bundleProduct) {
          return (
            bundleProduct.id == product.id &&
            bundleProduct.product_variation_id == product.product_variation_id
          );
        })
        .indexOf(true);

      $(".js-bundle-builder-modal").modal("show");
    },
    getDiscountRate: function(product) {
      if (!product.product_type_id) {
        return 0;
      }

      var _self = this;
      var price = product.price_vat,
        productTypeId = product.product_type_id,
        discountLevels = this.productTypes.find(function(productType) {
          return productType.id == productTypeId;
        }).configurator_discounts,
        rate = null;

      discountLevels.forEach(function(level) {
        if (
          (level.available_from_price == null ||
            level.available_from_price * _self.currencyValue < price) &&
          (level.available_to_price == null || level.available_to_price * _self.currencyValue > price)
        ) {
          rate = level.discount / 100;
        }
      });

      return rate;
    },
    removeProduct: function(index) {
      this.bundle.splice(index, 1);
    },
    calculateNewProductPrice: function(price, rate) {
      return price - price * rate;
    },
    fetchBundleProducts: function() {
      var _self = this;
      var storedData = localStorage.getItem(_self.id);

      if (storedData != null) {
        _self.bundle = JSON.parse(storedData);
      } else {
        _self.fetch("get", "/produkty-v-sete/" + _self.id, {}, function(
          response
        ) {
          if (!response.status) {
            return false;
          }

          _self.bundle = response.products.map(function(product) {
            product.bundle_configurator_price = _self.calculateNewProductPrice(
              product.price_vat,
              _self.getDiscountRate(product)
            );

            return product;
          });
        });
      }
    },
    selectVariation: function(variationId, variationValueId) {
      var _self = this;

      _self.loadingVariation = true;

      _self.product.selected_variation_values[variationId] =
        _self.product.variation_values[variationId][variationValueId];

      $.post(
        "/zmena-variacie/" + this.product.id,
        {
          variation_values: _.pluck(
            _self.product.selected_variation_values,
            "id"
          )
        },
        function(data) {
          if (data.status) {
            _self.product.selected_variation_values[variationId] =
              _self.product.variation_values[variationId][variationValueId];

            _self.product_variation_id = data.item.id;
            _self.product.product_variation_id = data.item.id;
            _self.product.model = data.item.model;
            _self.product.name = data.item.name;
            _self.product.price = data.item.price;
            _self.product.price_vat = data.item.price_vat;
            _self.product.image = data.item.image_raw;
            _self.product.status = data.item.status;
            _self.product.status_color = data.item.status_color;
          } else {
            delete _self.product.selected_variation_values[variationId];
          }

          _self.loadingVariation = false;
        }
      );
    },
    addToCart: function() {
      var _self = this;

      if (_self.bundle.length < 2) {
        return;
      }

      _self.addedToCart = true;

      var products = [];

      _self.bundle.forEach(function(product) {
        products.push({
          product_id: product.id,
          product_variation_id: product.product_variation_id,
          quantity: 1
        });
      });

      _self.fetch(
        "post",
        "/pridat-vlastny-set-do-kosika",
        { products: products, bundle_id: this.id },
        function(response) {
          if (!response.status) {
            _self.addedToCart = false;
            return false;
          }

          _self.clear();

          location.href = location.origin + "/nakupny-kosik";
        }
      );
    },
    clear: function() {
      this.bundle = [];
      this.product = {};
      this.cleared = true;

      localStorage.removeItem(this.storageName);
    },
    afterFetch: function() {
      this.$nextTick(function() {
        $('.js-builder-modal-image').one('load', function() {
          unfreezeScroll();

          setTimeout(function() {
            freezeScroll();
          }, 100);
        }).each(function() {
          if(this.complete) {
              $(this).trigger('load');
          }
        });
      });
    }
  },
  computed: {
    showModalWindow: function() {
      return (
        Object.keys(this.product).length > 0 &&
        this.product.constructor === Object
      );
    },
    storageName: function() {
      return this.id ? this.id : "NewBundle";
    },
    submitData: function() {
      return this.bundle.map(function(product) {
        return {
          product_id: product.id,
          product_variation_id: product.product_variation_id,
          price: product.bundle_configurator_price
        };
      });
    },
    bundlePrice: function() {
      var _self = this;

      return _self.bundle.reduce(function(total, product) {
        return (
          total +
          _self.calculateNewProductPrice(
            product.price_vat,
            _self.getDiscountRate(product)
          )
        );
      }, 0);
    },
    bundleOldPrice: function() {
      return this.bundle.reduce(function(total, product) {
        return total + product.price_vat;
      }, 0);
    },
    bundleDiscount: function() {
      return this.bundleOldPrice - this.bundlePrice;
    },
    alreadyInBundle: function() {
      var _self = this;

      if (!_self.product || _self.bundle.length == 0) {
        return false;
      }

      return (
        _self.bundle.filter(function(bundleProduct) {
          if (
            _self.product.id == bundleProduct.id &&
            _self.product.product_variation_id ==
              bundleProduct.product_variation_id
          ) {
            return true;
          }
        }).length > 0
      );
    }
  },
  updated: function() {
    this.$nextTick(function() {
      rEvent.dispatch("BundleBuilder.updated", {
        productsInBundle: this.$data.bundle.length
      });
    });
  },
  watch: {
    bundle: function(newBundle, oldBundle) {
      if (this.cleared) {
        return;
      }

      localStorage.setItem(
        this.id == null ? "NewBundle" : this.id,
        JSON.stringify(this.bundle)
      );
    }
  }
});
